module.exports = __webpack_public_path__ + "static/media/nortification_list_black.7a51b3c6.svg";